import dayjs from "dayjs";
import { Component, Vue,  Prop  } from "vue-property-decorator";
@Component({
})
export default class TimeAnalysisBarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly data: any;
  @Prop({ default: () => ([]) }) readonly allData: any;
  mounted() {
    this.init()
  }

  beforeDestroy(){

  }

  seriesDataItem(key){
    const data = []
    this.data.forEach(item => {
      data.push(item.wcsData[key.wcsName] || '0')
    });
    return data
  }

  init() {
    const seriesData = []
    const legendData = []
    let numberArr = [];
    let timerArr = []
    this.data.list.forEach(item =>{
      legendData.push(item.andonTypeCode+'-'+item.andonTypeName);
      numberArr.push(item.totalNumber);
      timerArr.push(item.totalSpendTime)
    })
    // const color = {}
    /* this.columns.map(column =>{
      color[column.wcsName] = column.color
    })
    this.columns.forEach(res =>{
      const seriesValue = {
        name: res.wcsName,
        type: 'bar',
        data: this.seriesDataItem(res),
        label: {
          show: true,
          position: 'top'
        },
        itemStyle: {
          normal: {
            color: param => {
              return color[param.seriesName]
            }
          }
        }
      }
      seriesData.push(seriesValue)
    }) */
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart as any
    );
    let thData = [{
      key:'workStationName',
      title:'工位名称'
    },{
      key:'andonTypeName',
      title:'呼叫类型名称'
    },{
      key:'andonReasonName',
      title:'呼叫原因'
    },{
      key:'employeeName',
      title:'呼叫人员'
    },{
      key:'callTime',
      title:'呼叫时间'
    },{
      key:'responseSpendTimeString',
      title:'响应时长'
    },{
      key:'fixSpendTimeString',
      title:'处理时长'
    },{
      key:'remark',
      title:'备注'
    }];
    // 指定图表的配置项和数据
    var option = {
      title:{
        show:false
      },
      tooltip:{
        trigger: 'axis',
        confine:"false",
        formatter: (params, ticket, callback) => {
          let name = params[0].name
          let nameArr = name.split('-')
          let andonTypeCode = nameArr[0]
          let andonTypeName = nameArr[1]
          let filterData = this.allData.filter(item => {
            return (item.andonTypeCode == andonTypeCode && item.andonTypeName == andonTypeName && this.data.workStationId === item.workStationId)
          })

          let html = '<table>'

          html += `<tr>`
          thData.forEach(th => {
            html += `<td style="padding:5px;border:solid 1px #ccc;">${th.title}</td>`
          })
          html += '</tr>'
          if(!filterData.length) {
            html += `<tr><td colspan="8" style="padding:5px;border:solid 1px #ccc;text-align: center;">暂无数据</td></tr>`
          } else {
            filterData.forEach(row => {
              html += '<tr>'
              thData.forEach(th => {
                let thStr = ''
                if (row[th.key]) {
                  if (th.key == 'callTime') {
                    thStr = dayjs(row[th.key]).format('YYYY-MM-DD HH:mm:ss')
                  } else if (th.key == 'remark') {
                    let arr = []
                    for (let i = 0; i < row[th.key].length; i += 10) {
                      let s = row[th.key].substring(i, i + 10)
                      arr.push(s)
                    }
                    thStr = arr.join('<br/>')
                  } else {
                    thStr = row[th.key]
                  }
                }
                html += `<td style="padding:5px;border:solid 1px #ccc;">${thStr}</td>`
              })

              html += '</tr>'
            })
          }
          html += '</table>'
          return html
        }
      },

      legend: {
        show: false
      },
      grid: {
        left: '40',
        right: '40',
        bottom: '4%',
        top: '40',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          show: true,
          interval: 0,
          formatter:function (value) {
            let arr = value.split('-');
            return arr[0]+'\n'+arr[1];
          }
        },
        axisLine: {onZero: true},
        data: legendData
      },
      yAxis: [
        {
          type: 'value',
          name:'(次数/次)',
          boundaryGap: true,
          interval:1,
          axisLine: {
              show: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel:{
            formatter: value =>{
              return value
            }
          },
        },
        {
          type: 'value',
          name:'(时长/h)',
          boundaryGap: true,
          max:function (value) {
            return Math.ceil(value.max/10)*10;
          },
          axisLine: {
              show: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          // axisLabel:{
          //   formatter: value =>{
          //     return value + 'h'
          //   }
          // },
        }
      ],
      series:[{
        name: '呼叫次数',
        type: 'bar',
        // barMinWidth:30,
        barMaxWidth:60,
        label:{
          show:true,
          formatter:'{c}次',
          position: 'top'
        },
        barGap:'0',
        data:numberArr
      },{
        name: '处理时间',
        type: 'bar',
        yAxisIndex: 1,
        // barMinWidth:40,
        barMaxWidth:60,
        label:{
          show:true,
          formatter:'{c}h',
          position: 'top'
        },
        barGap:'0',
        data:timerArr
      }]
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }

  // getheight(){
  //   const div = document.getElementById('black-main')
  //   return div.clientHeight - 110 + 'px'
  // }

  render() {
    return (
      <div class="chartBar-item">
        <div class="workStation-name">{this.data.workStationName}</div>
        <div ref="myChart" style={{height: '350px'}}></div>
      </div>
    )
  }
}
